import { ClassConstructor, instanceToPlain, plainToInstance } from 'class-transformer';

import deepmerge from 'deepmerge'; // TODO replace this?

function deepMerge<C>(model: ClassConstructor<C>, target: C, partial: Partial<C> | never): C {
  const plainTarget = instanceToPlain<C>(target);
  const plainPartial = instanceToPlain<Partial<C>>(partial);
  const plain = deepmerge(plainTarget, plainPartial) as C; // TODO casting == bad

  return plainToInstance<C, {}>(model, (plain as unknown) as Object);
}
export default deepMerge;
